import styled, { css } from 'styled-components';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const BodyWrapper = styled.div`
  width: 350px;
  
  & .sketch-picker {
    border-radius: 0 !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
  }

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          width: 100vw;
          height: 100%;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

